export function getQuizPresentation(quiz) {
    return quiz.presentation ?? {};
}
export function getAnalysisVisual(quiz) {
    return getQuizPresentation(quiz).analysisVisual ?? quiz.analysis.visual;
}
export function getQuestionTotal(quiz) {
    const counter = getQuizPresentation(quiz).counter;
    return counter?.enabled && Number.isInteger(counter.totalSteps) && counter.totalSteps > 0
        ? counter.totalSteps : undefined;
}
export function isCountedQuestion(quiz, questionId) {
    const counter = getQuizPresentation(quiz).counter;
    if (!counter?.enabled)
        return true;
    return !(counter.excludeQuestionIds ?? []).includes(questionId);
}
export function getQuestionOrdinal(quiz, visitedQuestionIds, questionId) {
    if (!isCountedQuestion(quiz, questionId))
        return undefined;
    const counted = visitedQuestionIds.filter((visitedQuestionId) => isCountedQuestion(quiz, visitedQuestionId));
    const index = counted.indexOf(questionId);
    return index >= 0 ? index + 1 : undefined;
}
